// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/deliverability/postmaster/:app_group_id/delivery_errors" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { deliverabilityPostmasterAppGroupIdDeliveryErrors } from "./constants";
import type {
  DeliverabilityPostmasterAppGroupIdDeliveryErrorsParams,
  DeliverabilityPostmasterAppGroupIdDeliveryErrorsResult,
} from "./types";

export const getDataTableDeliverabilityPostmasterAppGroupIdDeliveryErrors = reactQueryTableFetcherAdapter(
  deliverabilityPostmasterAppGroupIdDeliveryErrors,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortby,
      sortdir,
    }: DeliverabilityPostmasterAppGroupIdDeliveryErrorsParams
  ): Promise<DeliverabilityPostmasterAppGroupIdDeliveryErrorsResult> => {
    return fetch(
      `/deliverability/postmaster/${appGroupId}/delivery_errors`,
      "GET",
      {
        groupby,
        query: serializeQueryObjects(query),
        limit,
        start,
        start_date: query?.start_date,
        end_date: query?.end_date,
        app_group_id: appGroupId,
        sortby,
        sortdir,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
